<div class="user-actions" [class.--is-desktop]="isDesktop" [class.--is-mobile]="isMobile">
  <div class="__profile-actions --action-full">
    <button mat-button class="__profile-actions-item" mipBgColor="primary" (click)="openDownloadAppDialog()">
      <mip-icon icon="monetization-on"></mip-icon>
      <span mipTranslate="profile.header.monetize">Monetize</span>
    </button>

    <a mat-stroked-button class="__profile-actions-item" routerLink="/emotional-health" [mipGoBackReferrer] *ngIf="checkLanguageIsPt">
      <span>
        <mat-icon>accessibility</mat-icon>
        <span mipTranslate="profile.header.emotional-health" *ngIf="isMobile"> Emotional Health </span>
      </span>
    </a>
  </div>

  <div class="__profile-actions --action-full">
    <a mat-button class="__profile-actions-item" routerLink="/tutorials" [mipGoBackReferrer] mipBgColor="gray" *ngIf="isMobile">
      <mip-icon icon="tutorials"></mip-icon>
      <span mipTranslate="profile.header.tutorials">Tutorials</span>
    </a>

    <a mat-button class="__profile-actions-item" routerLink="invite" mipBgColor="gray">
      <mip-icon icon="profile" [solid]="true" size="2x">+</mip-icon>
      <span *ngIf="isMobile" mipTranslate="profile.header.invite">Invite</span>
    </a>
  </div>
</div>
